export const colors = {
  main: '#304354',
  mainLight: '#5b6e80',
  mainDark: '#071c2b',
  mainLightText: '#a0aebb',
  point: '#f7ce24',
  pointLight: '#f9d853',
  pointDark: '#ddb308',
};

